import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { CampaignService } from 'app/campaign/services/campaign.service';
import { SponsorGroupSchema } from 'app/campaign/structure/sponsor-group';
import { selectDialogState } from 'app/dialog/features/dialog.selectors';
import { DialogService } from 'app/dialog/services/dialog.service';

@Component({
  selector: 'app-sponsor-group-name',
  templateUrl: './sponsor-group-name.component.html',
  styleUrls: ['./sponsor-group-name.component.scss']
})
export class SponsorGroupNameComponent implements OnInit, OnDestroy {
  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));

  public sponsorGroup: UntypedFormGroup = null;

  public takeUntilSubject: Subject<any> = new Subject();
  
  constructor(
    private store: Store,
    private formBuilder: UntypedFormBuilder,
    private campaignService: CampaignService,
    private dialogService: DialogService
  ) { 
    this.sponsorGroup = this.formBuilder.group({});
    this.campaignService.generateForm(this.sponsorGroup, SponsorGroupSchema);
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.dialogService.closeDialogSubject.next(null);

    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

  close(dialog, value) {
    this.dialogService.closeDialogSubject.next(value);
    
    const { initialState: { action, callback } } = dialog;
    if(value) {
      if(action) {
        this.store.dispatch(action);
      }
      callback(value);
    }
  }
  
  confirm(dialog, value) {
    if(this.sponsorGroup.invalid) {
      return this.sponsorGroup.markAllAsTouched();
    }
    return this.close(dialog, value);
  }
}
